export const CONDITIONS = {
  IF: 'IF',
  REDIRECT_TO: 'REDIRECT_TO'
};
export const DRAG_TYPES = {
  FIELD: 'FIELD',
  CONDITION: 'CONDITION'
};
export const REDIRECT_TYPES = {
  SINGLE: 'SINGLE',
  CONDITIONAL: 'CONDITIONAL'
};
export const FALLBACK_TYPES = {
  INLINE_MESSAGE: 'INLINE_MESSAGE',
  MEETING: 'MEETING',
  EXTERNAL_URL: 'EXTERNAL_URL',
  HUBSPOT_PAGE: 'HUBSPOT_PAGE'
};
export const ROUTE_TYPE = {
  MEETING: 'MEETING',
  EXTERNAL_URL: 'EXTERNAL_URL',
  HUBSPOT_PAGE: 'HUBSPOT_PAGE'
};
export const ROUTE_STATE = {
  SIMPLE_ROUTE: 'SIMPLE_ROUTE',
  CONDITIONAL_ROUTE: 'CONDITIONAL_ROUTE',
  DISABLED: 'DISABLED'
};
export const PROPERTY_PARSER = {
  VALUE: 'VALUE',
  UPDATED_AT: 'UPDATED_AT',
  VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION: 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION'
};
export const FETCH_ROUTING_ERROR = 'FETCH_FORM_ROUTING_ERROR';
const FORM_ROUTING_VALIDATION_ERROR_PREFIX = 'FormsRoutingValidationError';
export const UPDATE_VALIDATION_ERROR = {
  [`${FORM_ROUTING_VALIDATION_ERROR_PREFIX}.FORM_NOT_FOUND`]: 'ROUTING_FORM_NOT_FOUND',
  [`${FORM_ROUTING_VALIDATION_ERROR_PREFIX}.PROPERTY_MISMATCH_BETWEEN_FORM_AND_ROUTING`]: 'PROPERTY_MISMATCH_BETWEEN_FORM_AND_ROUTING',
  [`${FORM_ROUTING_VALIDATION_ERROR_PREFIX}.MEETINGS_LINKS_INVALID`]: 'INVALID_MEETING_LINK_PRESENT',
  [`${FORM_ROUTING_VALIDATION_ERROR_PREFIX}.PUBLISHED_LISTS_MODIFIED`]: 'PUBLISHED_LISTS_MODIFIED',
  [`${FORM_ROUTING_VALIDATION_ERROR_PREFIX}.HUBSPOT_PAGES_INVALID`]: 'HUBSPOT_PAGES_INVALID'
};
export const MAX_FIELDS_ALLOWED = 4;
export const MAX_ROUTING_LISTS_PER_POLICY = 4;
export const DEFAULT_FILTER_BRANCH = {
  routingPolicyFilter: {
    propertyFilterOperation: {
      operator: undefined,
      value: '',
      propertyType: undefined
    },
    objectTypeId: '',
    propertyName: ''
  },
  routeType: ROUTE_TYPE.MEETING,
  routeValue: undefined
};
export const INITIAL_CONDITION_REDIRECT = {
  defaultRouteType: FALLBACK_TYPES.INLINE_MESSAGE,
  routeState: ROUTE_STATE.CONDITIONAL_ROUTE,
  routingPolicyGroup: [{
    routingPolicyList: [DEFAULT_FILTER_BRANCH]
  }]
};
export const SINGLE_REDIRECT = {
  defaultRouteType: FALLBACK_TYPES.MEETING,
  defaultRouteValue: '',
  routingPolicyGroup: [],
  routeState: ROUTE_STATE.SIMPLE_ROUTE
};
export const RESET_REDIRECT = {
  defaultRouteType: FALLBACK_TYPES.INLINE_MESSAGE,
  routingPolicyGroup: [],
  routeState: ROUTE_STATE.DISABLED,
  defaultRouteValue: ''
};
export const DEFAULT_INPUT_VALUES = {
  WITHIN_TIME: 1,
  BETWEEN_NUMBER: [0, 0],
  NUMBER: 0,
  STRING: [],
  ENUMERATION: []
};
export const DAY_AGO = 'DAY_AGO';
export const DAY_FROM_NOW = 'DAY_FROM_NOW';